// selectors
import { getPageName } from "Selectors/ui";

export const updateUI = (keyPath, value) => (dispatch) => {
	dispatch({ type: "UI:UPDATE", keyPath, value });
};

/**
 * Wraps the `updateUI` action and updates a value within the page ui.
 *
 * @param {array} keyPath - update key path within the page ui
 * @param {any} value - value of the key path
 */
export const changePageUI = (keyPath, value) => (dispatch, getState) => {
	const state = getState();
	const pageName = getPageName(state);
	const newKeyPath = [pageName].concat(keyPath);

	dispatch(updateUI(newKeyPath, value));
};
